<!-- 查看试卷 -->
<template>
  <div class="studentExamPaper" v-loading="allLoading">
    <div>
      <div class="examInfo">
        <el-row style="margin-bottom: 50px">
          <el-col :span="8">
            科目名称：{{ examInfo.subjectName }}
          </el-col>
          <el-col :span="8">
            级别：{{ examInfo.subjectLevel_dictText }}
          </el-col>
          <el-col :span="8">
            考生姓名：<span v-if="perInfo">{{ perInfo.name }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            证件号码：{{ examInfo.idNumber }}
          </el-col>
          <el-col :span="8">
            提交时间：<span v-if="perInfo">{{ $tagTime(perInfo.subTime, "yyyy年MM月dd日") }}</span>
          </el-col>
          <el-col :span="8">
            成绩（不包含上传音频）：
            <!-- {{ examInfo.score1 }} -->
            {{perInfo.soce?examInfo.score1:0}}
          </el-col>
        </el-row>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="乐理知识" name="1"></el-tab-pane>
        <el-tab-pane label="音乐素养" name="2"></el-tab-pane>
        <el-tab-pane label="上传音频" name="3"></el-tab-pane>
        <el-tab-pane label="练耳" name="4"></el-tab-pane>
      </el-tabs>
      <div class="testList">
        <p class="titScole">归属部分得分：{{ testDetail.soce }}/{{ testDetail.allSoce }}分</p>
        <div class="testItem" v-for="( test, index ) in  testDetail.date " :key="index">
          <div class="testTitle">
            <p style="display: flex;width: 83%;">（{{ test.tx | txName }}）{{ test.name }}({{
              test.score }}分) <i v-if="test.tx == 3" style="color:#1890ff;margin-left: 20px;">考生答案:{{ test.content }}</i>
            <div v-if="test.tx == 2">
              <img v-if="test.content && test.answer == test.content.split(',').sort().join(',')"
                src="@/assets/img/yes1.svg" alt="">
              <img v-else src="@/assets/img/no.svg" alt="">
            </div>
            <div v-if="test.tx != 4 && test.tx != 2">
              <img v-if="test.content && test.answer == test.content" src="@/assets/img/yes1.svg" alt="">
              <img v-else src="@/assets/img/no.svg" alt="">
            </div>
            <div v-if="test.tx != 4" style="color:#1890ff">正确答案:{{ test.answer }}</div>
            </p>
          </div>
          <template v-if="Array.isArray(test.nameUrl)">
            <div v-for="(file, sum) in test.nameUrl" :key="sum + 'file'">
              <div class="autioDiv" style="height:100%" v-if="$expForMat(file.fileName)">
                <autioCate :name="false" :proSty="true" width="100%" height="50px" :audioSrc="file" />
              </div>
              <img v-else :src="file.url" style="height: 80px;height: 100px;">
            </div>
          </template>
          <div v-for="( option, i ) in  test.options " :key="i" class="option">
            <p class="optTitle" v-if="test.tx == 1">
              <el-radio v-model="test.content" :label="option.num" :disabled="true">
                <i></i>
              </el-radio> {{ option.num }}.{{ option.content }}
            </p>
            <p class="optTitle" v-if="test.tx == 2 || test.tx == 3">
              <template v-if="test.content">
                <el-checkbox v-model="test.content.split(',')" :label="option.num" :disabled="true">
                  <i></i>
                </el-checkbox> {{ option.num }}.{{ option.content }}
              </template>
              <template v-else>
                <el-checkbox v-model="noneCheck" :label="option.num" :disabled="true">
                  <i></i>
                </el-checkbox> {{ option.num }}.{{ option.content }}
              </template>
            </p>
            <template v-if="option.fj && option.fj.url">
              <div class="autioDiv" style="height:100%" v-if="$expForMat(option.fj.fileName)">
                <autioCate :name="false" :proSty="true" width="100%" height="50px" :audioSrc="option.fj" />
              </div>
              <div class="optImgDiv" v-else style="height: 80px;height: 100px;">
                <img :src="option.fj.url">
              </div>
            </template>
          </div>
          <div v-if="test.tx == 4 && test.contentFj" style="margin-top:20px">
            <p style="color:#1890ff;">考生答案:</p>
            <autioCate :name="false" :proSty="true" width="100%" height="50px" :audioSrc="test.contentFj" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import autioCate from '../../components/autioCate.vue'

export default {
  name: 'studentExamPaper',
  components: { autioCate },
  data() {
    return {
      examInfo: {},
      testList: [],
      radio: 0,
      checked: [],
      value1: '',
      selectTx: [],
      selectType: [],
      txList: [],
      typeList: [],
      query: { tx: '', type: '' },
      loading: false,
      allLoading: false,
      simuList: [],
      zt: "0",
      times: [],
      isModify: false,
      testDetail: [],
      perInfo: {},
      activeName: '1',
      noneCheck: []
    }
  },
  methods: {
    handleClick(tab, event) {
      this.getExam(this.activeName)
    },
    amend() {
      this.simuList = this.testDetail
      this.zt = String(this.testDetail[0].zt)
      if (this.zt == '1') {
        this.times = [this.testDetail[0].startTime, this.testDetail[0].endTime]
      }
      this.isModify = true
    },
    changeZt() {
      this.times = []
    },
    getExam(type) {
      this.loading = true
      // this.$axios.get(`/process/answer/${this.examInfo.subjectId}/${this.examInfo.subjectLevel}/${type}/${this.examInfo.userId}`).then((res) => {
      this.$axios.get(`/process/answer/${this.examInfo.examId}/${this.examInfo.subjectLevel}/${type}/${this.examInfo.userId}`).then((res) => {
        this.testDetail = res.data.data
        console.log(77, this.testDetail);
        this.loading = false
      });
    },
    getTestDetail() {
      console.log(555, this.examInfo);
      this.$axios.get(`/process/paper/${this.examInfo.examId}/${this.examInfo.subjectLevel}/${this.examInfo.userId}`).then((res) => {
        this.perInfo = res.data.data
        this.loading = false
      });
      this.getExam(1)
    },
  },
  created() {
    this.examInfo = JSON.parse(this.$route.query.row)
    this.getTestDetail()
  },
}
</script>

<style lang="scss" scoped>
.titScole {
  width: 80%;
  margin: auto;
  color: #1890ff;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 18px;
}

.amendBtn {
  position: absolute;
  right: 0;
}

.optImgDiv {
  width: 100px;
  height: 100px;

  img {
    width: 100%;
    height: 100%;
    margin: auto;
    object-fit: contain;
  }
}

.option {
  margin-bottom: 10px;
  padding-left: 20px;

  .optTitle {
    margin-bottom: 10px;
  }
}

.examInfo {
  width: 100%;
  box-sizing: border-box;
  height: 150px;
  background-color: #f6f6f6;
  margin-bottom: 20px;
  padding: 20px 0 0 180px;
  font-size: 18px;
  font-weight: 600;
}

.setExam {
  width: 100%;
  display: flex;
  // justify-content: space-between;

  .examTitle {
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 20px;
  }

  .testInfo {
    background-color: #fff;
    padding: 10px;
    margin-bottom: 20px;


  }

  .allTest {
    width: 45%;
    background-color: #f6f6f6;
    padding: 20px;
  }
}

.testTitle {
  display: flex;
  color: #333;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.testList {
  .testItem {
    width: 80%;
    margin: auto;
    border: 2px dashed #e4e4e4;
    padding: 20px;
    margin-bottom: 20px;
  }
}
</style>